(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctb-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var q = e.target.closest('.ctb-faq-q');
  if (!q) return;
  var root = q.closest('.ctb-faq-sec');
  var item = q.parentElement;
  var a = q.nextElementSibling;
  var open = item.classList.contains('is-open');
  root.querySelectorAll('.ctb-faq-item.is-open').forEach(function (it) {
    it.classList.remove('is-open');
    it.querySelector('.ctb-faq-a').style.maxHeight = null;
    it.querySelector('.ctb-faq-q').setAttribute('aria-expanded', 'false');
  });
  if (!open) {
    item.classList.add('is-open');
    a.style.maxHeight = a.scrollHeight + 'px';
    q.setAttribute('aria-expanded', 'true');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctb-reviews"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      var track = document.querySelector('[data-rev-track]');
      if (track && !track.dataset.revInit) {
        track.dataset.revInit = '1';
        var cards = track.querySelectorAll('.ctb-rev-card');
        var n = cards.length / 2;
        var loopW = 0;
        var paused = false, resumeTimer = null;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function measure(){
          if (cards.length >= 2 && n >= 1) {
            loopW = cards[n].offsetLeft - cards[0].offsetLeft;
          }
        }
        measure();
        // start a little in, so a card peeks on the left immediately
        if (loopW > 0) track.scrollLeft = Math.min(loopW * 0.5, cards[0].getBoundingClientRect().width);

        function pause(){ paused = true; if (resumeTimer) clearTimeout(resumeTimer); }
        function resumeSoon(){ if (resumeTimer) clearTimeout(resumeTimer); resumeTimer = setTimeout(function(){ paused = false; }, 1100); }

        var speed = 0.4;
        function tick(){
          if (!paused && loopW > 0) track.scrollLeft += speed;
          if (loopW > 0){
            if (track.scrollLeft >= loopW) track.scrollLeft -= loopW;
            else if (track.scrollLeft < 0) track.scrollLeft += loopW;
          }
          requestAnimationFrame(tick);
        }
        if (!reduce) requestAnimationFrame(tick);

        window.addEventListener('resize', function(){ measure(); });
        window.addEventListener('load', function(){ measure(); });

        // drag-to-scroll (mouse) + touch pause + turquoise active card
        var down = false, startX = 0, startScroll = 0, isMouse = false;
        track.addEventListener('pointerdown', function(e){
          down = true; isMouse = (e.pointerType === 'mouse');
          startX = e.clientX; startScroll = track.scrollLeft; pause();
          var card = e.target.closest('.ctb-rev-card');
          if (card) card.classList.add('is-touch');
        });
        window.addEventListener('pointermove', function(e){
          if (!down || !isMouse) return;
          track.scrollLeft = startScroll - (e.clientX - startX);
        });
        function endDrag(){
          if (!down) return;
          down = false; resumeSoon();
          track.querySelectorAll('.ctb-rev-card.is-touch').forEach(function(c){ c.classList.remove('is-touch'); });
        }
        window.addEventListener('pointerup', endDrag);
        window.addEventListener('pointercancel', endDrag);
      }

      // ----- intro toast -----
      var toast = document.querySelector('[data-rev-toast]');
      if (toast && !toast.dataset.revInit) {
        toast.dataset.revInit = '1';
        var sec = document.getElementById('ctb-rev-anchor');
        var dismissed = false;
        try { dismissed = sessionStorage.getItem('ctbRevToast') === 'off'; } catch (e) {}
        if (dismissed) { toast.parentNode && toast.parentNode.removeChild(toast); }
        else {
          document.body.appendChild(toast);
          toast.hidden = false;
          var slides = toast.querySelectorAll('.ctb-rev-toast__slide');
          var idx = 0, cyc = null;
          function close(setFlag){
            toast.classList.remove('is-in');
            if (setFlag) { try { sessionStorage.setItem('ctbRevToast','off'); } catch (e) {} }
            if (cyc) clearInterval(cyc);
            setTimeout(function(){ toast.parentNode && toast.parentNode.removeChild(toast); }, 600);
          }
          toast.querySelector('[data-rev-close]').addEventListener('click', function(){ close(true); });
          slides.forEach(function(s){
            s.addEventListener('click', function(){
              if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
              close(true);
            });
          });
          setTimeout(function(){ toast.classList.add('is-in'); }, 1600);
          if (slides.length > 1) {
            cyc = setInterval(function(){
              slides[idx].classList.remove('is-active');
              idx = (idx + 1) % slides.length;
              slides[idx].classList.add('is-active');
            }, 3200);
          }
          // auto-retire after a while (without remembering, so it can return next visit)
          setTimeout(function(){ if (toast.classList.contains('is-in')) close(false); }, 17000);
        }
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
